import type { Maybe } from '@adornis/base/utilTypes.js';
import { SchoolType } from '../entities/School.js';

export enum AbstractSchoolType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export function getAbstractSchoolType(schoolType: Maybe<SchoolType>): AbstractSchoolType {
  if (!schoolType) return AbstractSchoolType.SECONDARY;
  switch (schoolType) {
    case SchoolType.GRUNDSCHULE:
      return AbstractSchoolType.PRIMARY;
    case SchoolType.GYMNASIUM:
    case SchoolType.HAUPTSCHULE:
    case SchoolType.REALSCHULE:
      return AbstractSchoolType.SECONDARY;
  }
}
